var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card shadow mb-4"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_header),expression:"show_header"}],staticClass:"card-header py-3 bg-dark"},[_c('h6',{staticClass:"m-0 font-weight-bold"},[_vm._t("titleCard")],2)]),_vm._v(" "),_c('div',{class:`card-body ${_vm.padding}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }